/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { AssetContentType } from './AssetContentType';
import {
    AssetContentTypeFromJSON,
    AssetContentTypeFromJSONTyped,
    AssetContentTypeToJSON,
} from './AssetContentType';

/**
 * 
 * @export
 * @interface StartAssetUploadRequestContent
 */
export interface StartAssetUploadRequestContent {
    /**
     * Original file name selected by the user.
     * @type {string}
     * @memberof StartAssetUploadRequestContent
     */
    fileName: string;
    /**
     * 
     * @type {AssetContentType}
     * @memberof StartAssetUploadRequestContent
     */
    contentType: AssetContentType;
    /**
     * File size in bytes.
     * @type {number}
     * @memberof StartAssetUploadRequestContent
     */
    contentLengthBytes: number;
    /**
     * Optional checksum provided by the client.
     * @type {string}
     * @memberof StartAssetUploadRequestContent
     */
    checksumSha256?: string;
}


/**
 * Check if a given object implements the StartAssetUploadRequestContent interface.
 */
export function instanceOfStartAssetUploadRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "contentLengthBytes" in value;
    return isInstance;
}

export function StartAssetUploadRequestContentFromJSON(json: any): StartAssetUploadRequestContent {
    return StartAssetUploadRequestContentFromJSONTyped(json, false);
}

export function StartAssetUploadRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartAssetUploadRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'fileName': json['fileName'],
        'contentType': AssetContentTypeFromJSON(json['contentType']),
        'contentLengthBytes': json['contentLengthBytes'],
        'checksumSha256': !exists(json, 'checksumSha256') ? undefined : json['checksumSha256'],
    };
}

export function StartAssetUploadRequestContentToJSON(value?: StartAssetUploadRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'fileName': value.fileName,
        'contentType': AssetContentTypeToJSON(value.contentType),
        'contentLengthBytes': value.contentLengthBytes,
        'checksumSha256': value.checksumSha256,
    };
}

